import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { API_ROOT } from "@/lib/api";
import { Cable } from "lucide-react";

/**
 * Frontend proxy for the SSO handoff.
 * HaloPSA's custom button can point either directly at the backend at
 * `<PUBLIC_URL>/api/sso/cpanel?halo_user_ref=...` (recommended, no JS needed),
 * or at this route which just forwards the browser.
 */
export default function SSOHandoffPage() {
  const [params] = useSearchParams();
  useEffect(() => {
    const halo_user_ref = params.get("halo_user_ref") || params.get("user") || "";
    const halo_session = params.get("halo_session") || "";
    const target = new URL(`${API_ROOT}/sso/cpanel`);
    if (halo_user_ref) target.searchParams.set("halo_user_ref", halo_user_ref);
    if (halo_session) target.searchParams.set("halo_session", halo_session);
    window.location.replace(target.toString());
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <div className="w-full max-w-sm rounded-lg border border-border bg-card p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-9 w-9 items-center justify-center rounded-md bg-primary text-primary-foreground">
          <Cable className="h-4 w-4" />
        </div>
        <div className="mb-3 h-8 w-8 mx-auto animate-spin rounded-full border-2 border-border border-t-primary" />
        <h1 className="font-heading text-lg font-semibold">Opening your cPanel…</h1>
        <p className="mt-1 text-sm text-muted-foreground">Verifying your Halo session and creating a one-time login link.</p>
      </div>
    </div>
  );
}
